export default __webpack_public_path__ + "static/stockCity-f91ead83a051f9d299a02d97f1348e09.jpeg";